
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/forgot-password",
      function () {
        return require("private-next-pages/my-account/forgot-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/forgot-password"])
      });
    }
  